// forms.js
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { pricing, VATrate } from '../../utils/price_config';
import { paypal } from '../../store/actions';
import { quantitySelect } from '../../utils/google';

class BillingForm_Class extends React.Component {
  handleClick = creditsPackage => {
    const { dispatch } = this.props;
    dispatch(paypal.setCredits(creditsPackage));
    quantitySelect();
  };

  totalPrice = subtotal => {
    return (subtotal * VATrate + subtotal).toFixed(2);
  };

  activeCredit = credit => {
    const {
      creditsPackage: { name }
    } = this.props;
    return credit === name ? 'active-credit' : '';
  };

  render() {
    return (
      <Fragment>
        <table className="price-table">
          <tbody>
            {pricing.credits.map((creditsPackage, i) => {
              const creditsAmount = creditsPackage.name;
              const creditsPrice = creditsPackage.price;
              return (
                <tr
                  className={this.activeCredit(creditsAmount)}
                  key={`credits${i}`}
                  onClick={() => this.handleClick(creditsPackage)}
                >
                  <th>{`${creditsAmount} credits`}</th>
                  <td className="discount">{`£${(
                    this.totalPrice(creditsPrice) / creditsAmount
                  ).toFixed(2)} / pic`}</td>
                  <td>
                    <span className="price">
                      <span className="curr" />
                      <span className="num">{`£${this.totalPrice(
                        creditsPrice
                      )}`}</span>
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  creditsPackage: state.paypal.creditsPackage
});

export const BillingForm = connect(mapStateToProps)(BillingForm_Class);

export default BillingForm;



// WEBPACK FOOTER //
// ./src/comps/Billing/Forms.js